import * as React from 'react';

import ChatFooter from 'bundles/ai-coach-platform/components/patterns/chat/ChatFooter';

const CourseraAiFooter = () => {
  return <ChatFooter />;
};

export default CourseraAiFooter;
